// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/comboboxDropdown.scss';
import React from 'react';
import { Popover } from '../../Popover/Popover';
export const ComboboxDropdown = React.forwardRef(({ comboboxRef, isOpened = false, position = null, minWidth = 0, children, classNameDropdown = null, classNameList = null, onOutsideClick }, ref) => {
    if (!isOpened) {
        return null;
    }
    const dropdownClassNames = ['combobox-dropdown', classNameDropdown];
    const listClassNames = ['combobox-dropdown-list', classNameList];
    const dropdownClassName = dropdownClassNames.filter(Boolean).join(' ');
    const listClassName = listClassNames.filter(Boolean).join(' ');
    return (React.createElement(Popover, { ref: ref, className: dropdownClassName, left: position === null || position === void 0 ? void 0 : position.left, top: position === null || position === void 0 ? void 0 : position.top, minWidth: minWidth, excludeRefs: [comboboxRef], onOutsideClick: onOutsideClick },
        React.createElement("div", { className: listClassName, role: "listbox", "aria-label": "Options" }, children)));
});
